import { formatStateOrStatus } from './formatStatus';

export function getRecurringOrderStatus({
  endTime,
  startTime,
  todayEnd,
  status,
}: {
  readonly endTime?: number | null;
  readonly startTime: number;
  readonly todayEnd: number;
  readonly status: string;
}): string {
  const todayIsAfterEndDate = endTime != null && todayEnd > endTime;
  const todayIsBeforeStartDate = todayEnd < startTime;

  if (todayIsAfterEndDate) {
    return 'Ended';
  }
  if (todayIsBeforeStartDate) {
    return 'Not Started';
  }

  return formatStateOrStatus(status);
}
